//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import subNavSelection from "~/components/header-item-selection";
import BannerTypeProduct from "~/components/content-elements/banner-type-product";
import ProductPresentation from "~/components/loading-placeholders/product-presentation-pl";
import productBox from "~/components/product-boxes/style-2";
export default {
  components: {
    BannerTypeProduct,
    productBox,
    subNavSelection,
    ProductPresentation,
  },
  data() {
    return {};
  },
  mounted() {
    this.$store.dispatch("tea-products/getWatteBoutique"),
      this.$store.dispatch("tea-range/getProductByRange", {
        rangeName: "Dilmah Watte Boutique Tea",
      });
  },

  computed: {
    pageData() {
      if (this.$store.state["tea-products"].watteBoutique != null) {
        return Object.assign(
          this.$store.state["tea-products"].watteBoutique.estate_teas,
          { links: this.$store.state["tea-products"].watteBoutique.links }
        );
      }
    },
    dmcData() {
      if (this.$store.state["tea-range"].productByRange != null) {
        return this.$store.state["tea-range"].productByRange;
      }
    },

    products() {
      if (this.dmcData != null && this.dmcData.single_region_teas != null) {
        return this.dmcData.single_estate_teas.map((product) => ({
          image: product.product_images[0],
          name: product.product_name,
          description: product.one_line_caption,
          id: product.product_name,
          shopLink: product.online_shop,
        }));
      }
    },
  },
};
